import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { CATEGORIES } from '@/(routers)/boards/editor/block/definitions/categories';
import { FieldStyledLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledLabel';

defineBlock({
    type: 'math_random',
    colour: CATEGORIES.operator.color,
    tooltip: '指定した範囲の乱数を返します',
    movable: true,
    deletable: true,
    inline: true,
    output: 'Number',
    inputs: [
        {
            kind: 'dummy',
            fields: [
                {
                    type: 'field',
                    instance: () =>
                        new FieldStyledLabel('RANDOM', {
                            fontSize: 12,
                            fontWeight: 'bold',
                        }),
                },
                { type: 'label', text: ' ' },
            ],
        },
        {
            kind: 'value',
            name: 'FROM',
            check: 'Number',
            shadow: { type: 'number', fields: { NUM: 1 } },
        },
        {
            kind: 'dummy',
            fields: [{ type: 'label', text: 'から' }],
        },
        {
            kind: 'value',
            name: 'TO',
            check: 'Number',
            shadow: { type: 'number', fields: { NUM: 10 } },
        },
        {
            kind: 'dummy',
            fields: [{ type: 'label', text: 'のランダムな数値 ' }],
        },
    ],
});
